<div class="content content-fixed">
  <div>
    <div class="container">
      <div class="mb-3 page-title-box d-sm-flex align-items-center justify-content-between">
        <h3 class="mb-0">{{ 'Inline Assessments' | translate }}</h3>
        <div class="mb-3 flex">
          <input
            type="text"
            [(ngModel)]="searchTerm"
            (input)="filterData()"
            placeholder="Search by ID, name, or email"
            class="form-control"
          />
          <div class="flex justify-center items-center ml-2">
            <input type="checkbox" (change)="isEnable()">
            <p class="ml-1">Include Deleted</p>
          </div>
        </div>
      </div>

      <div *ngIf="!isLoading" class="inline-Assessment">
        <div class="table-wrapper">
          <table class="table table-striped" [class.no-data]="pagedData.length===0">
            <thead class="header">
              <tr [ngClass]="{'unbold-header':pagedData.length===0 && !isLoading}">
                <th>Id</th>
                <th>Name</th>
                <th>Email</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of pagedData">
                <td>{{ item.id }}</td>
                <td>
                  {{ item.payload.candidate ? item.payload.candidate.firstName : '' }}
                  {{ item.payload.candidate ? item.payload.candidate.lastName : '' }}
                </td>
                <td>{{item.payload.candidate.email}}</td>
                <td>{{ item.status }}</td>
                <td>
                  <button
                  class="view-response-button  h-8 btn btn-sm  btn-uppercase btn-default justify-center flex items-center confirm w-24 "
                  (click)="onviewResponseClick(item)"
                  [disabled]="isLoading">
                  <i class=" fas fa-folder-open text-base iconbg "></i>
                  <i class="fas fa-search -ml-2 -mb-1 dual-color-icon text-xl"></i>                
                </button>                
                </td>
              </tr> 
              <tr *ngIf="pagedData.length === 0 && !isLoading">
                <td colspan="5" class="no-data-found">
                  No data found.
                </td>
              </tr>
              <tr *ngIf="isLoading">
                <td colspan="5" class="loading">
                  <app-spinner></app-spinner>
                  Loading...
                </td>
              </tr>
              <tr *ngIf="error">
                <td colspan="5" class="error">
                  {{ error }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="pagination container mt-auto">
        <div class="pagination-controls ">
          <button class="btn btn-sm bt-3 btn-uppercase btn-default justify-center flex items-center" (click)="goToFirstPage()" [disabled]="currentPage === 1">
            <i class="fa fa-fast-backward" aria-hidden="true"></i>
          </button>

          <button class="btn btn-sm bt-3 btn-uppercase btn-default justify-center flex items-center" (click)="prevPage()" [disabled]="currentPage === 1">
            <i class="fa fa-step-backward" aria-hidden="true"></i>
          </button>
          <!-- Current Page Info -->
          <span class="mt-2 bt-3">Page {{ currentPage }} of {{ totalPages }}</span>

          <button class="btn btn-sm bt-3 btn-uppercase btn-default justify-center flex items-center" (click)="nextPage()" [disabled]="currentPage >= totalPages">
            <i class="fa fa-step-forward" aria-hidden="true"></i>
          </button>

          <button class="btn btn-sm bt-3 btn-uppercase btn-default justify-center flex items-center" (click)="goToLastPage()" [disabled]="currentPage === totalPages">
            <i class="fa fa-fast-forward" aria-hidden="true"></i>
          </button>
        </div>
      </div>